import { IAccreditationsConfig } from '@orcha/types/package';

export const searchFetcher = (
  url: string,
  accreditationsConfig?: IAccreditationsConfig
) =>
  fetch(url, {
    headers: {
      'orcha-accreditation-config': JSON.stringify(accreditationsConfig),
    },
  }).then((res) => res.json());
